import Commons from '../../../../Services/Common/Common';
import dayjs from 'dayjs';

/**
 * SAM_BASIC_01 스키마
 * - fields: 폼/그리드에서 공통으로 쓰는 필드 정의
 *   - initial: 초기값
 *   - label: 필드명
 *   - required: 필수 입력 여부
 *   - requiredWhen: 언제 필수인지 조건
 *
 * - mapper: 저장/삭제 API payload 생성 규칙
 *   - mapRowsBySchema(rows, mapper, context)로 payload를 만듬
 *   - context에는 userInfo 등이 들어오며(mapRowsBySchema에 기본족으로 정의되어 있음),
 *     화면에서 추가로 필요한 값(custCd 등)을 context로 넘겨줄 수 있다.
 */
export const SAM_BASIC_01_Schema = {
  fields: {
    no: { initial: '', label: 'NO' },
    chaebun: { initial: '', label: '체번' },
    custCd: { initial: '', label: '사업장코드' },
    fileName: { initial: '', label: '파일명', required: 'Y' },
    date: { initial: '', label: '작성일', required: 'Y' },
    createId: { initial: '', label: '작성자' },
    mapBlob: { initial: null, label: '블롭' },
    mapFile: { initial: null, label: '파일' },
    mapFileName: { initial: '', label: '파일명(사용자가 올린 이름)' },
    saveName: { initial: '', label: '파일명(저장되는 이름)' },
    filePath: { initial: '', label: '파일 경로' },
    previewFilePath: { initial: '', label: '미리보기 파일 경로' },
  },

  mapper: {
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      StartDate: (_, context) =>
        Commons.EncryptAES(context.search?.startDate || '') || '',
      EndDate: (_, context) =>
        Commons.EncryptAES(context.search?.endDate || '') || '',
      DepCd: (_, context) =>
        Commons.EncryptAES(context.search?.depCd || '') || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || '') || '',
    },

    save1: {
      Chaebun: (row) => Commons.EncryptAES(row.chaebun || '') || '',
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      DepCd: (_, context) =>
        Commons.EncryptAES(context.search?.depCd || '') || '',
      Date: (row, context) => {
        if (!row.date) return '';
        const dateValue = dayjs(row.date).format('YYYY-MM-DD');
        return Commons.EncryptAES(dateValue) || '';
      },
      FileName: (row) => Commons.EncryptAES(row.fileName || '') || '',
      SaveName: (row) => Commons.EncryptAES(row.saveName || '') || '',
      FilePath: (row, context) => {
        if (!row.saveName) return '';
        const filePath = `SafeWorkProcedure/${context.search?.custCd}/SAF_BASIC_01/${row.saveName}`;
        return Commons.EncryptAES(filePath) || '';
      },
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    delete1: {
      Chaebun: (row) => Commons.EncryptAES(row.chaebun) || '',
    },
  },
};
